// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, string } from 'prop-types'
import { ErrorsList } from 'components'

const Warning = props => {
  const {
    idRoot = 'warning-modal',
    modalErrors,
    modalHeading,
    modalMessage,
  } = props

  return (
    <div className={'path-details-footer-modal'}>
      <h3 className={'center-text uppercase padding-half'}>
        <span
          className={'text-blue-dark'}
          id={`${idRoot}-heading`}>
          {modalHeading}
        </span>
        <span className={'alert-decoration'} />
      </h3>
      {
        modalErrors
          ? (
            <ErrorsList
              errors={modalErrors}
              idRoot={idRoot}
              message={modalMessage} />
          ) : (
            <p className={'padding-half center-text'}>
              <strong id={`${idRoot}-message`}>{modalMessage}</strong>
            </p>
          )
      }
    </div>
  )
}

Warning.propTypes = {
  idRoot: string,
  modalErrors: array,
  modalHeading: string.isRequired,
  modalMessage: string.isRequired,
}

export default Warning
